import { ApiResponse } from "../../apiResponse";
import Axios from "../../axios";

export function createLearner(learnerData: object): Promise<ApiResponse> {
  return Axios.post("v1/learners/students", learnerData);
}
